module.exports = __webpack_public_path__ + "assets/img/cloud5.010bde78.webp";